import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getAllNotifications, markAllAsRead, markAsRead } from "./actions/notificationActions";

export interface NotificationState {
  allNotifications: any[];
  unreadCount: number;
  loader: true | false;
  loader2: true | false;
}

const initialState: NotificationState = {
  allNotifications: [],
  unreadCount: 0,
  loader: false,
  loader2: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setAllNotifications: (state: any, value) => {
      state.allNotifications = value.payload;
    },
    setUnreadCount: (state: any, value) => {
      state.unreadCount = value.payload;
    },
    resetNotification: (state: any) => {
      state.allNotifications = [];
    },
  },
  extraReducers: (builder) => {
    // Post getAllNotifications methods
    builder.addCase(getAllNotifications.pending, (state) => {
      state.loader2 = true;
    });
    builder.addCase(getAllNotifications.rejected, (state) => {
      state.loader2 = false;
    });
    builder.addCase(getAllNotifications.fulfilled, (state, { payload }) => {
      state.loader2 = false;
      // state.allNotifications = payload.notificationList;
      state.allNotifications.push(...payload.notificationList);
    });
    // ./getAllNotifications methods

    // Post markAsRead methods
    builder.addCase(markAsRead.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(markAsRead.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(markAsRead.fulfilled, (state) => {
      state.loader = false;
    });
    // ./markAsRead methods

    // Post markAllAsRead methods
    builder.addCase(markAllAsRead.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(markAllAsRead.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(markAllAsRead.fulfilled, (state) => {
      state.loader = false;
    });
    // ./markAllAsRead methods
  },
});

export const { setAllNotifications, setUnreadCount, resetNotification } = notificationSlice.actions;

export const allNotificationsList = (state: RootState) => state.notifications.allNotifications;
export const unreadCountValue = (state: RootState) => state.notifications.unreadCount;
export const loader = (state: RootState) => state.notifications.loader;
export const loader2 = (state: RootState) => state.notifications.loader2;
